var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive } ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu',{attrs:{"notifications":_vm.notifications},on:{"showBillDetailFromNotify":_vm.showBillDetailFromNotify}}),_c('template',{slot:"links"},[(_vm.permission.includes('bill-management'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Quản lý đơn hàng',
          icon: 'receipt_long',
          path: '/bill-management',
        }}}):_vm._e(),(_vm.permission.includes('manage-products'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Quản lý sản phẩm',
          icon: 'store',
          path: '/manage-products',
        }}}):_vm._e(),(_vm.permission.includes('user-management'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Quản lý nhân viên',
          icon: 'assignment_ind',
          path: '/user-management',
        }}}):_vm._e(),(_vm.permission.includes('admin-management'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Quản lý admin',
          icon: 'admin_panel_settings',
          path: '/admin-management',
        }}}):_vm._e(),(_vm.permission.includes('customer-management'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Quản lý đại lý',
          icon: 'home_work',
          path: '/customer-management',
        }}}):_vm._e(),(_vm.permission.includes('warehouse-management'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Quản lý nhập kho',
          icon: 'account_balance',
          path: '/warehouse-management',
        }}}):_vm._e(),(_vm.permission.includes('news-managements'))?_c('sidebar-item',{attrs:{"link":{
          name: 'Tin tức và khuyến mại',
          icon: 'perm_media',
          path: '/news-managements',
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar',{attrs:{"notifications":_vm.notifications},on:{"showBillDetailFromNotify":_vm.showBillDetailFromNotify}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":100,"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }